import { z } from 'zod';

export const faqItemSchema = z.object({
  question: z.string(),
  answer: z.string()
});

export const faqContentSchema = z.object({
  updatedAt: z.string().optional(),
  items: z.array(faqItemSchema).min(1)
});

export type FaqItem = z.infer<typeof faqItemSchema>;
export type FaqContent = z.infer<typeof faqContentSchema>;


